
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#fff","d":"M0 0h32v32H0z"}}),_c('path',{attrs:{"d":"M23.741 26c-.493 0-.986-.119-1.48-.357-1.725-1.072-.492-3.095.74-5 .494-.714 1.233-2.024 1.357-2.62-.863.239-2.836 2.025-4.069 3.096-2.958 2.5-5.917 5.12-8.012 3.214-1.973-1.785.493-4.88 3.451-8.69 1.48-2.024 5.055-6.548 4.192-7.381h-.124c-2.465 0-9.492 6.428-13.683 10.952a1.355 1.355 0 01-1.726.12 1.242 1.242 0 01-.123-1.667C6.113 15.762 15.359 6 19.796 6c1.11 0 1.603.476 1.973.833 2.219 2.262-.863 6.19-4.068 10.476-1.356 1.786-3.452 4.524-3.699 5.596.863 0 3.206-2.143 4.562-3.334 2.588-2.262 4.93-4.285 6.78-3.571.616.238 1.11.714 1.233 1.31.493 1.428-.494 3.095-1.603 4.88-.37.477-.74 1.31-.986 1.786.493-.238 1.233-.833 1.849-1.428.37-.477 1.233-.596 1.726-.12.493.358.616 1.191.123 1.667-.123-.238-1.972 1.905-3.945 1.905z","fill":"#525F7F"}})])
          )
        }
      }
    